/* ═══════════════════════════════════════════════
   A'JOHRI PRE-LAUNCH THEME — VANILLA JS
   ═══════════════════════════════════════════════ */

document.addEventListener('DOMContentLoaded', function () {
  var isMobileStatic = window.matchMedia('(max-width: 768px)').matches;
  if (isMobileStatic) {
    document.body.classList.add('is-mobile-static');
  }

  if (!isMobileStatic) {
    initScrollAnimations();
    initEditorialMotion();
  }
  initNavigation();
  initHomeHeroVideo();
  initWeavingLoom();
  initMakingGallery();
  initCountdown();
  if (!isMobileStatic) {
    initSequentialWords();
    initStaggeredColorWords();
    initScrollRevealText();
    initParallax();
  }
  initFooterBannerPicker();
  initPhoneInputs();
  initWaitlistForm();
  initContactForm();
  restorePostedFormState({
    formId: 'home-cta-form',
    stateSelector: '[data-home-cta-form-state]',
    successTargetId: 'home-cta-done',
    errorTargetId: 'home-cta-form-wrap'
  });
  restorePostedFormState({
    formId: 'waitlist-form',
    stateSelector: '[data-waitlist-form-state]',
    successTargetId: 'waitlist-done',
    errorTargetId: 'waitlist-form-wrap'
  });
});

var __phoneInputRegistry = [];

function setPhoneFallbackState(entry, enabled) {
  if (!entry) return;

  var fallback = entry.querySelector('[data-phone-fallback]');
  var phoneInput = entry.querySelector('.js-phone-input');
  if (!fallback || !phoneInput) return;

  fallback.hidden = !enabled;
  entry.classList.toggle('is-phone-fallback', enabled);
  phoneInput.placeholder = enabled ? 'Phone number' : 'Phone';
}

function initPhoneInputs() {
  var phoneInputs = document.querySelectorAll('.js-phone-input');
  if (!phoneInputs.length) return;

  if (!window.intlTelInput) {
    phoneInputs.forEach(function (input) {
      var entry = input.closest('[data-phone-entry]');
      var codeInput = entry ? entry.querySelector('[data-phone-country-code]') : null;

      setPhoneFallbackState(entry, true);
      if (codeInput) {
        codeInput.addEventListener('input', function () {
          codeInput.value = String(codeInput.value || '').replace(/\D/g, '').slice(0, 3);
        });
      }
    });
    return;
  }

  phoneInputs.forEach(function (input) {
    if (input.dataset.phoneInputInit) return;

    var entry = input.closest('[data-phone-entry]');

    var iti = intlTelInput(input, {
      initialCountry: 'in',
      separateDialCode: true,
      nationalMode: false,
      autoPlaceholder: 'aggressive',
      formatOnDisplay: true,
      dropdownContainer: document.body,
      utilsScript: 'https://cdn.jsdelivr.net/npm/intl-tel-input@18.5.2/build/js/utils.js'
    });

    setPhoneFallbackState(entry, false);
    input.dataset.phoneInputInit = '1';
    input.dataset.phoneInputIndex = String(__phoneInputRegistry.length);
    __phoneInputRegistry.push({ input: input, iti: iti });
  });
}

function getPhoneNumberValue(input) {
  if (!input) return '';

  var index = input.dataset && input.dataset.phoneInputIndex;
  if (index !== undefined && __phoneInputRegistry[index] && __phoneInputRegistry[index].iti) {
    var value = __phoneInputRegistry[index].iti.getNumber();
    if (value) return value;
  }

  var entry = input.closest('[data-phone-entry]');
  var codeInput = entry ? entry.querySelector('[data-phone-country-code]') : null;
  var rawValue = String(input.value || '').trim();
  var normalizedValue = rawValue.replace(/\s+/g, '');

  if (!normalizedValue) return '';
  if (normalizedValue.charAt(0) === '+') return normalizedValue;

  if (codeInput && !codeInput.closest('[hidden]')) {
    var countryCode = String(codeInput.value || '').replace(/\D/g, '').slice(0, 3);
    var localNumber = normalizedValue.replace(/\D/g, '');

    if (!localNumber) return countryCode ? '+' + countryCode : '';
    if (countryCode) return '+' + countryCode + localNumber;
    return localNumber;
  }

  return normalizedValue;
}

function cleanContactPostedUrl() {
  if (!window.history || !window.history.replaceState) return;
  if (window.location.search.indexOf('contact_posted=true') === -1) return;

  window.history.replaceState({}, document.title, window.location.pathname + window.location.hash);
}

function scrollToPostedFormState(target) {
  if (!target) return;

  window.requestAnimationFrame(function () {
    window.setTimeout(function () {
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 140);
  });
}

function restorePostedFormState(config) {
  if (!config || !config.formId || !config.stateSelector) return;

  var form = document.getElementById(config.formId);
  if (!form) return;

  var stateEl = form.querySelector(config.stateSelector);
  if (!stateEl) return;

  var postedSuccessfully = stateEl.getAttribute('data-posted-successfully') === 'true';
  var hasErrors = stateEl.getAttribute('data-has-errors') === 'true';

  if (!postedSuccessfully && !hasErrors) return;

  cleanContactPostedUrl();
  scrollToPostedFormState(document.getElementById(postedSuccessfully ? config.successTargetId : config.errorTargetId));
}

/* ═══════════════════════════════════════════════
   1. SCROLL REVEAL ANIMATIONS
   ═══════════════════════════════════════════════ */

function initScrollAnimations() {
  var elements = document.querySelectorAll('.reveal, .clip-reveal, .scale-in');
  if (!elements.length) return;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px 0px -40px 0px', threshold: 0 });

  elements.forEach(function (el) { observer.observe(el); });
}

function initEditorialMotion() {
  var sectionSelectors = [
    '.video-hero',
    '.subhero',
    '.founder-hero',
    '.brand-section',
    '.philosophy-section',
    '.home-cta',
    '.hero-cinematic',
    '.film-letter',
    '.film-craft',
    '.film-artisans',
    '.film-founder',
    '.film-metamorphosis',
    '.kaarigar-section',
    '.contact-section',
    '.making-hero-v2',
    '.making-atlas',
    '.making-closing',
    '.making-atelier',
    '.site-footer'
  ];

  var itemSelectors = [
    'h1', 'h2', 'h3', 'p', 'blockquote',
    '.brand-section__media',
    '.founder-hero__image-block',
    '.founder-hero__portrait-wrap',
    '.founder-hero__label',
    '.founder-hero__wordmark',
    '.founder-hero__hindi-name',
    '.founder-hero__bio',
    '.philosophy-section__pillar',
    '.home-cta__tier-wrap',
    '.home-cta__form-wrap',
    '.home-cta__done',
    '.kaarigar-card',
    '.making-textile',
    '.making-atelier-card',
    '.making-place-card',
    '.making-chapter',
    '.footer-brand',
    '.footer-col',
    'img',
    'video',
    'button',
    'a'
  ];

  var sections = document.querySelectorAll(sectionSelectors.join(','));
  if (!sections.length) return;

  sections.forEach(function (section) {
    if (!section.hasAttribute('data-editorial-group')) {
      section.setAttribute('data-editorial-group', '');
    }

    var items = section.querySelectorAll(itemSelectors.join(','));
    var seen = [];

    items.forEach(function (item) {
      if (!item || item.closest('[data-editorial-item]')) return;
      if (item.closest('.mobile-menu')) return;
      if (item.closest('.footer-legal')) return;
      if (item.closest('.footer-ornament')) return;
      if (item.closest('.making-gallery__viewport')) return;
      if (item.closest('.home-cta__tier-wrap') && !item.classList.contains('home-cta__tier-wrap')) return;
      if (item.closest('.philosophy-section__pillar') && !item.classList.contains('philosophy-section__pillar')) return;
      if (seen.indexOf(item) !== -1) return;

      seen.push(item);
      item.setAttribute('data-editorial-item', '');
    });
  });

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    sections.forEach(function (section) {
      section.classList.add('is-editorial-visible');
    });
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;

      var items = entry.target.querySelectorAll('[data-editorial-item]');
      items.forEach(function (item, index) {
        item.style.setProperty('--editorial-delay', Math.min(index * 85, 700) + 'ms');
      });

      entry.target.classList.add('is-editorial-visible');
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -12% 0px', threshold: 0.12 });

  sections.forEach(function (section) {
    observer.observe(section);
  });
}

function initMakingGallery() {
  var sections = document.querySelectorAll('.making-atlas');
  if (!sections.length) return;

  sections.forEach(function (atlas) {
    var viewport = atlas.querySelector('[data-making-gallery-viewport]');
    var cards = Array.prototype.slice.call(atlas.querySelectorAll('[data-making-gallery-card]'));
    if (!viewport || !cards.length) return;

    var mq = window.matchMedia('(min-width: 769px)');
    var viewportWidth = 0;
    var cardWidth = 280;
    var gap = 34;
    var totalWidth = 0;
    var curveDepth = 115;
    var rafId = null;
    var spacing = 0;
    var scroll = { current: 0 };
    var isHoverPaused = false;
    var isDragging = false;
    var lastTime = 0;
    var autoSpeed = 44;
    var dragStartX = 0;
    var dragStartScroll = 0;
    var dragMoved = false;
    var suppressClicksUntil = 0;

    initMediaSwitchers(atlas);

    function normalizeScroll(value) {
      if (!totalWidth) return 0;
      return ((value % totalWidth) + totalWidth) % totalWidth;
    }

    function refresh() {
      viewportWidth = viewport.clientWidth;
      cardWidth = cards[0].offsetWidth || 280;
      gap = Math.max(24, Math.min(42, viewportWidth * 0.03));
      spacing = cardWidth + gap;
      totalWidth = Math.max(cards.length * spacing, 1);
    }

    function positionCards() {
      if (!mq.matches) {
        cards.forEach(function(card) {
          card.style.transform = '';
          card.style.opacity = '';
          card.style.zIndex = '';
        });
        return;
      }

      var centerShift = (viewportWidth - cardWidth) / 2;
      cards.forEach(function(card, index) {
        var wrappedX = centerShift + index * spacing - scroll.current;
        while (wrappedX < -cardWidth - gap) {
          wrappedX += totalWidth;
        }
        while (wrappedX > viewportWidth + gap) {
          wrappedX -= totalWidth;
        }
        var x = wrappedX;
        var cardCenter = wrappedX + cardWidth / 2;
        var relative = (cardCenter - viewportWidth / 2) / (viewportWidth / 2);
        var limited = Math.max(-1.35, Math.min(1.35, relative));
        var depth = Math.min(Math.abs(limited), 1.15);
        var y = depth * depth * curveDepth;
        var rotation = limited * 9;
        var scale = 1 - Math.min(depth * 0.07, 0.07);
        var opacity = 1 - Math.min(Math.abs(limited) * 0.2, 0.2);
        var zIndex = 1000 - Math.round(Math.abs(relative) * 100);

        card.style.transform = 'translate3d(' + x + 'px, ' + y + 'px, 0) rotate(' + rotation + 'deg) scale(' + scale + ')';
        card.style.opacity = opacity.toFixed(3);
        card.style.zIndex = String(zIndex);
      });
    }

    function tick(time) {
      rafId = window.requestAnimationFrame(tick);
      if (!mq.matches) return;
      if (!lastTime) {
        lastTime = time;
      }
      var deltaSeconds = Math.min((time - lastTime) / 1000, 0.05);
      lastTime = time;
      if (!isHoverPaused && !isDragging) {
        scroll.current = normalizeScroll(scroll.current + autoSpeed * deltaSeconds);
      }
      positionCards();
    }

    function onPointerEnter() {
      if (!mq.matches) return;
      isHoverPaused = true;
    }

    function onPointerLeave() {
      if (!mq.matches) return;
      isHoverPaused = false;
    }

    function onPointerDown(event) {
      if (!mq.matches) return;
      isDragging = true;
      dragMoved = false;
      dragStartX = event.clientX;
      dragStartScroll = scroll.current;
      lastTime = 0;
      viewport.setPointerCapture(event.pointerId);
    }

    function onPointerMove(event) {
      if (!mq.matches || !isDragging) return;
      var deltaX = event.clientX - dragStartX;
      if (Math.abs(deltaX) > 6) {
        dragMoved = true;
      }
      scroll.current = normalizeScroll(dragStartScroll - deltaX);
      positionCards();
    }

    function onPointerUp(event) {
      if (!isDragging) return;
      if (dragMoved) {
        suppressClicksUntil = window.performance.now() + 250;
      }
      isDragging = false;
      dragMoved = false;
      lastTime = 0;
      if (event && typeof viewport.releasePointerCapture === 'function') {
        try {
          viewport.releasePointerCapture(event.pointerId);
        } catch (error) {}
      }
    }

    function onClickCapture(event) {
      if (window.performance.now() < suppressClicksUntil) {
        event.preventDefault();
        event.stopPropagation();
      }
    }

    function onResize() {
      lastTime = 0;
      refresh();
      scroll.current = normalizeScroll(scroll.current);
      positionCards();
    }

    viewport.addEventListener('mouseenter', onPointerEnter);
    viewport.addEventListener('mouseleave', onPointerLeave);
    viewport.addEventListener('pointerdown', onPointerDown);
    viewport.addEventListener('pointermove', onPointerMove);
    viewport.addEventListener('pointerup', onPointerUp);
    viewport.addEventListener('pointercancel', onPointerUp);
    viewport.addEventListener('pointerleave', onPointerUp);
    viewport.addEventListener('click', onClickCapture, true);
    window.addEventListener('resize', onResize);

    if (mq.addEventListener) {
      mq.addEventListener('change', onResize);
    } else if (mq.addListener) {
      mq.addListener(onResize);
    }

    refresh();
    positionCards();
    if (!rafId) {
      rafId = window.requestAnimationFrame(tick);
    }
  });
}

function initMediaSwitchers(scope) {
  var switchers = scope.querySelectorAll('[data-making-media-switcher]');
  if (!switchers.length) return;

  switchers.forEach(function (switcher) {
    var items = Array.prototype.slice.call(switcher.querySelectorAll('[data-making-media-item]'));
    var thumbs = Array.prototype.slice.call(switcher.querySelectorAll('[data-making-media-thumb]'));
    if (!items.length || !thumbs.length) return;
    var activeIndex = 0;
    var autoTimer = null;
    var autoDelay = 3400;

    function setActive(id) {
      activeIndex = thumbs.findIndex(function (thumb) {
        return thumb.getAttribute('data-making-media-thumb') === id;
      });

      items.forEach(function (item) {
        var isActive = item.getAttribute('data-making-media-item') === id;
        item.classList.toggle('is-active', isActive);
        var video = item.querySelector('video');
        if (video) {
          if (isActive) {
            video.currentTime = 0;
            var playPromise = video.play();
            if (playPromise && typeof playPromise.catch === 'function') {
              playPromise.catch(function () {});
            }
          } else {
            video.pause();
          }
        }
      });

      thumbs.forEach(function (thumb) {
        var isActive = thumb.getAttribute('data-making-media-thumb') === id;
        thumb.classList.toggle('is-active', isActive);
      });
    }

    function clearAutoTimer() {
      if (!autoTimer) return;
      window.clearInterval(autoTimer);
      autoTimer = null;
    }

    function startAutoTimer() {
      clearAutoTimer();
      autoTimer = window.setInterval(function () {
        if (!thumbs.length) return;
        activeIndex = (activeIndex + 1) % thumbs.length;
        setActive(thumbs[activeIndex].getAttribute('data-making-media-thumb'));
      }, autoDelay);
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function (event) {
        event.preventDefault();
        setActive(thumb.getAttribute('data-making-media-thumb'));
        startAutoTimer();
      });
    });

    switcher.addEventListener('mouseenter', clearAutoTimer);
    switcher.addEventListener('mouseleave', startAutoTimer);

    var activeThumb = switcher.querySelector('[data-making-media-thumb].is-active');
    setActive(activeThumb ? activeThumb.getAttribute('data-making-media-thumb') : thumbs[0].getAttribute('data-making-media-thumb'));
    startAutoTimer();
  });
}

function initFooterBannerPicker() {
  var picker = document.querySelector('[data-footer-banner-picker]');
  var strip = document.querySelector('[data-footer-banner-strip]');
  if (!picker || !strip) return;

  var buttons = Array.prototype.slice.call(picker.querySelectorAll('[data-footer-banner-button]'));
  var options = Array.prototype.slice.call(strip.querySelectorAll('[data-footer-banner-option]'));
  if (!buttons.length || !options.length) return;

  function setActive(id) {
    buttons.forEach(function (button) {
      var isActive = button.getAttribute('data-footer-banner-button') === id;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    options.forEach(function (option) {
      option.classList.toggle('is-active', option.getAttribute('data-footer-banner-option') === id);
    });
  }

  buttons.forEach(function (button) {
    button.addEventListener('click', function () {
      setActive(button.getAttribute('data-footer-banner-button'));
    });
  });
}

/* ═══════════════════════════════════════════════
   2. NAVIGATION
   ═══════════════════════════════════════════════ */

function initNavigation() {
  var nav = document.getElementById('prelaunch-nav');
  if (!nav) return;

  var hamburger = document.getElementById('nav-hamburger');
  var mobileMenu = document.getElementById('mobile-menu');
  var menuOpen = false;

  function syncNavOffset() {
    document.body.style.setProperty('--site-nav-offset', nav.getBoundingClientRect().height + 'px');
  }

  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', function () {
      menuOpen = !menuOpen;
      mobileMenu.style.display = menuOpen ? 'flex' : 'none';
      hamburger.setAttribute('aria-expanded', menuOpen ? 'true' : 'false');
      hamburger.querySelector('.hamburger-icon').style.display = menuOpen ? 'none' : 'block';
      hamburger.querySelector('.close-icon').style.display = menuOpen ? 'block' : 'none';
      window.requestAnimationFrame(syncNavOffset);
    });
  }

  window.addEventListener('resize', syncNavOffset);
  window.requestAnimationFrame(syncNavOffset);

  // Smooth scroll to waitlist
  document.querySelectorAll('.scroll-to-waitlist').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      var waitlist = document.getElementById('waitlist');
      if (waitlist) {
        e.preventDefault();
        if (menuOpen && mobileMenu) {
          menuOpen = false;
          mobileMenu.style.display = 'none';
          if (hamburger) hamburger.setAttribute('aria-expanded', 'false');
        }
        waitlist.scrollIntoView({ behavior: 'smooth' });
      }
    });
  });
}

/* ═══════════════════════════════════════════════
   3. WEAVING LOOM SVG ANIMATION
   ═══════════════════════════════════════════════ */

function initWeavingLoom() {
  var container = document.getElementById('weaving-loom-container');
  if (!container) return;

  var FABRIC_LEFT = 14;
  var TOTAL_COLS = 34;
  var COL_W = 14;
  var LOOM_W = FABRIC_LEFT + TOTAL_COLS * COL_W + 14;
  var LOOM_H = 220;
  var WARP_COUNT = 50;
  var WARP_SPACING = LOOM_H / (WARP_COUNT + 1);
  var SHUTTLE_CROSS_MS = 800;
  var COL_PAUSE_MS = 200;

  // Deliberate color bands — each brand color gets a visible stripe
  var WEFT_PALETTE = [
    // Orchid mist band (purple foundation)
    '#917799','#917799','#9E82A6','#917799',
    // Vibrant orange accent stripe
    '#FF741F','#FF741F','#FF741F',
    // Orchid bloom band (light purple)
    '#C4AFD1','#C4AFD1','#B89EC4','#C4AFD1',
    // Pickled beet accent stripe (deep maroon)
    '#4D243D','#4D243D','#4D243D',
    // Egret band (ivory/cream)
    '#F3EBE0','#E8DDD0','#F3EBE0','#E8DDD0',
    // Orchid mist return
    '#917799','#856D8E','#917799',
    // Orange accent return
    '#FF741F','#FF741F',
    // Blackberry cordial band (dark purple)
    '#422A47','#422A47','#422A47',
    // Orchid bloom fade out
    '#C4AFD1','#9E82A6','#917799','#856D8E',
    // Final ivory
    '#F3EBE0','#E8DDD0'
  ];

  function warpColor(i) {
    var mod = i % 6;
    if (mod === 0) return '#C4AFD1';
    if (mod === 1) return '#917799';
    if (mod === 2) return '#D8C8E0';
    if (mod === 3) return '#A68BAE';
    if (mod === 4) return '#C4AFD1';
    return '#B89EC4';
  }

  var ns = 'http://www.w3.org/2000/svg';

  function createSVG(tag, attrs) {
    var el = document.createElementNS(ns, tag);
    for (var k in attrs) el.setAttribute(k, attrs[k]);
    return el;
  }

  var svg = createSVG('svg', {
    viewBox: '-12 -20 ' + (LOOM_W + 24) + ' ' + (LOOM_H + 40),
    style: 'overflow:visible; width:100%; max-width:580px; height:auto;',
    'aria-hidden': 'true',
    role: 'presentation'
  });
  container.appendChild(svg);

  // Defs
  var defs = createSVG('defs', {});
  var shuttleGrad = createSVG('linearGradient', { id: 'shuttleWood', x1: '0', y1: '0', x2: '1', y2: '0' });
  [['0%','#6B4520'],['25%','#8B6914'],['50%','#A07D28'],['75%','#8B6914'],['100%','#6B4520']].forEach(function(s) {
    var stop = createSVG('stop', { offset: s[0], 'stop-color': s[1] });
    shuttleGrad.appendChild(stop);
  });
  defs.appendChild(shuttleGrad);
  svg.appendChild(defs);

  // Loom frame
  svg.appendChild(createSVG('rect', { x: -8, y: -8, width: 10, height: LOOM_H + 16, rx: 4, fill: '#5C3A1E', opacity: 0.6 }));
  svg.appendChild(createSVG('rect', { x: -6, y: -8, width: 6, height: LOOM_H + 16, rx: 3, fill: '#7A5230', opacity: 0.4 }));
  svg.appendChild(createSVG('rect', { x: LOOM_W - 2, y: -8, width: 10, height: LOOM_H + 16, rx: 4, fill: '#5C3A1E', opacity: 0.6 }));
  svg.appendChild(createSVG('rect', { x: LOOM_W, y: -8, width: 6, height: LOOM_H + 16, rx: 3, fill: '#7A5230', opacity: 0.4 }));
  svg.appendChild(createSVG('rect', { x: -10, y: -16, width: LOOM_W + 20, height: 6, rx: 3, fill: '#6B4F10', opacity: 0.3 }));
  svg.appendChild(createSVG('rect', { x: -10, y: LOOM_H + 10, width: LOOM_W + 20, height: 6, rx: 3, fill: '#6B4F10', opacity: 0.3 }));

  // Reed/beater bar
  var reed = createSVG('rect', { x: FABRIC_LEFT, y: -10, width: 3, height: LOOM_H + 20, rx: 1.5, fill: '#8B6914', opacity: 0.5 });
  svg.appendChild(reed);

  // Warp threads
  var warpLines = [];
  for (var i = 0; i < WARP_COUNT; i++) {
    var y = WARP_SPACING * (i + 1);
    var line = createSVG('line', { x1: 0, y1: y, x2: LOOM_W, y2: y, stroke: warpColor(i), 'stroke-width': 1.1, 'stroke-opacity': 0.45 });
    svg.appendChild(line);
    warpLines.push({ el: line, baseY: y, isUpper: i % 2 === 0 });
  }

  // Fabric group
  var fabricGroup = createSVG('g', {});
  svg.appendChild(fabricGroup);

  // Shuttle group
  var shuttleG = createSVG('g', { style: 'display:none' });
  svg.appendChild(shuttleG);

  // Build shuttle shape
  var shuttleBody = createSVG('path', {
    d: 'M 10,2 C 3,8 0,22 0,32 C 0,42 3,56 10,62 C 17,56 20,42 20,32 C 20,22 17,8 10,2 Z',
    fill: 'url(#shuttleWood)', stroke: '#5C3A1E', 'stroke-width': 0.7
  });
  shuttleG.appendChild(createSVG('path', {
    d: 'M 10,2 C 3,8 0,22 0,32 C 0,42 3,56 10,62 C 17,56 20,42 20,32 C 20,22 17,8 10,2 Z',
    fill: '#000', opacity: 0.12, transform: 'translate(1.5,1.5)'
  }));
  shuttleG.appendChild(shuttleBody);
  shuttleG.appendChild(createSVG('path', { d: 'M 10,14 C 6,18 5,25 5,32 C 5,39 6,46 10,50 C 14,46 15,39 15,32 C 15,25 14,18 10,14 Z', fill: '#3D2010', opacity: 0.3 }));
  shuttleG.appendChild(createSVG('ellipse', { cx: 10, cy: 32, rx: 3.5, ry: 8, fill: '#6B4520', opacity: 0.6 }));
  var shuttleThread = createSVG('line', { x1: 10, y1: 32, x2: 10, y2: -10, stroke: '#917799', 'stroke-width': 1.2, 'stroke-linecap': 'round', opacity: 0.55 });
  shuttleG.appendChild(shuttleThread);
  shuttleG.appendChild(createSVG('path', { d: 'M 10,2 L 7,5 Q 10,4 13,5 Z', fill: '#C49A2A', opacity: 0.7 }));
  shuttleG.appendChild(createSVG('path', { d: 'M 10,62 L 7,59 Q 10,60 13,59 Z', fill: '#C49A2A', opacity: 0.7 }));

  // Cloth beam roll
  var clothBeam = createSVG('g', { opacity: 0, style: 'display:none' });
  clothBeam.appendChild(createSVG('ellipse', { cx: -2, cy: LOOM_H / 2, rx: 5, ry: LOOM_H * 0.35, fill: '#C49A2A' }));
  clothBeam.appendChild(createSVG('ellipse', { cx: -2, cy: LOOM_H / 2, rx: 3, ry: LOOM_H * 0.35, fill: '#5C3A1E' }));
  svg.appendChild(clothBeam);

  var wovenCols = 0;
  var cancelled = false;

  function setShed(open) {
    var amt = open ? 2.5 : 0;
    warpLines.forEach(function (w) {
      var off = w.isUpper ? -amt : amt;
      w.el.setAttribute('y1', w.baseY + off);
      w.el.setAttribute('y2', w.baseY + off);
    });
  }

  function drawWovenCol(col) {
    var cx = FABRIC_LEFT + col * COL_W + COL_W * 0.5;
    var color = WEFT_PALETTE[col % WEFT_PALETTE.length];
    var brightness = 1 + Math.sin(col * 0.7) * 0.06;
    var g = createSVG('g', {});
    var curve = WARP_SPACING * 0.15;
    var halfGap = WARP_SPACING * 0.48;

    for (var w = 0; w < WARP_COUNT; w++) {
      var wy = WARP_SPACING * (w + 1);
      var isOver = (w + col) % 2 === 0;
      var top = wy - halfGap;
      var bot = wy + halfGap;

      if (isOver) {
        g.appendChild(createSVG('path', {
          d: 'M ' + cx + ',' + top + ' Q ' + (cx + curve) + ',' + wy + ' ' + cx + ',' + bot,
          fill: 'none', stroke: color, 'stroke-width': COL_W * 0.75, 'stroke-linecap': 'round', opacity: 0.92 * brightness
        }));
      } else {
        g.appendChild(createSVG('path', {
          d: 'M ' + cx + ',' + top + ' Q ' + (cx - curve) + ',' + wy + ' ' + cx + ',' + bot,
          fill: 'none', stroke: color, 'stroke-width': COL_W * 0.6, 'stroke-linecap': 'round', opacity: 0.3 * brightness
        }));
      }
    }

    // Warp-over redraw
    for (var w2 = 0; w2 < WARP_COUNT; w2++) {
      var wy2 = WARP_SPACING * (w2 + 1);
      if ((w2 + col) % 2 === 0) continue;
      g.appendChild(createSVG('line', {
        x1: cx - COL_W * 0.55, y1: wy2, x2: cx + COL_W * 0.55, y2: wy2,
        stroke: warpColor(w2), 'stroke-width': 1.1, opacity: 0.65
      }));
    }

    fabricGroup.appendChild(g);
  }

  function easeInOutQuad(t) {
    return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
  }

  function weaveCol(col) {
    if (cancelled) return;
    var goingDown = col % 2 === 0;
    var shuttleX = FABRIC_LEFT + col * COL_W + COL_W / 2;

    shuttleG.style.display = '';
    shuttleThread.setAttribute('stroke', WEFT_PALETTE[col % WEFT_PALETTE.length]);
    shuttleThread.setAttribute('y2', goingDown ? -10 : 74);
    setShed(true);

    var start = performance.now();
    function tick(now) {
      if (cancelled) return;
      var t = Math.min((now - start) / SHUTTLE_CROSS_MS, 1);
      var ease = easeInOutQuad(t);
      var y = goingDown ? ease * LOOM_H : LOOM_H * (1 - ease);
      shuttleG.setAttribute('transform', 'translate(' + (shuttleX - 10) + ',' + (y - 32) + ')');

      if (t < 1) {
        requestAnimationFrame(tick);
      } else {
        setShed(false);
        shuttleG.style.display = 'none';
        setTimeout(function () {
          if (cancelled) return;
          drawWovenCol(col);
          wovenCols = col + 1;
          reed.setAttribute('x', FABRIC_LEFT + wovenCols * COL_W - 1);

          if (wovenCols > 3) {
            clothBeam.style.display = '';
            clothBeam.setAttribute('opacity', '0.25');
          }

          if (col + 1 >= TOTAL_COLS) {
            setTimeout(function () {
              if (cancelled) return;
              while (fabricGroup.firstChild) fabricGroup.removeChild(fabricGroup.firstChild);
              wovenCols = 0;
              reed.setAttribute('x', FABRIC_LEFT);
              clothBeam.style.display = 'none';
              setTimeout(function () { weaveCol(0); }, 800);
            }, 2500);
          } else {
            setTimeout(function () { weaveCol(col + 1); }, COL_PAUSE_MS);
          }
        }, 150);
      }
    }
    requestAnimationFrame(tick);
  }

  // Start after delay, only when visible
  var loomObserver = new IntersectionObserver(function (entries) {
    if (entries[0].isIntersecting) {
      loomObserver.disconnect();
      setTimeout(function () { weaveCol(0); }, 1600);
    }
  }, { threshold: 0.2 });
  loomObserver.observe(container);
}

/* ═══════════════════════════════════════════════
   4. COUNTDOWN TIMER
   ═══════════════════════════════════════════════ */

function initCountdown() {
  // Find all countdown timers on the page
  var timers = document.querySelectorAll('[data-launch]');
  if (!timers.length) return;

  timers.forEach(function (timer) {
    var launchStr = timer.getAttribute('data-launch') || '2026-05-05T00:00:00';
    var launchDate = new Date(launchStr).getTime();
    // Support both .countdown-value and .hero-countdown__value
    var values = timer.querySelectorAll('.countdown-value, .hero-countdown__value');
    if (!values.length) return;

    function update() {
      var now = Date.now();
      var diff = Math.max(0, launchDate - now);
      var days = Math.floor(diff / (1000 * 60 * 60 * 24));
      var hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
      var minutes = Math.floor((diff / (1000 * 60)) % 60);
      var seconds = Math.floor((diff / 1000) % 60);
      var vals = [days, hours, minutes, seconds];

      values.forEach(function (el, i) {
        var newVal = String(vals[i]).padStart(2, '0');
        if (el.textContent !== newVal) {
          el.textContent = newVal;
          el.classList.remove('flip');
          void el.offsetWidth;
          el.classList.add('flip');
        }
      });
    }

    update();
    setInterval(update, 1000);
  });
}

/* ═══════════════════════════════════════════════
   5. SEQUENTIAL WORD REVEAL
   ═══════════════════════════════════════════════ */

function initSequentialWords() {
  var containers = document.querySelectorAll('.sequential-words');
  if (!containers.length) return;

  containers.forEach(function (container) {
    var spans = container.querySelectorAll('span');
    spans.forEach(function (span, i) {
      span.style.opacity = '0';
      span.style.transform = 'translateY(30px)';
      span.style.transition = 'opacity 0.6s cubic-bezier(0.22,1,0.36,1) ' + (i * 0.15) + 's, transform 0.6s cubic-bezier(0.22,1,0.36,1) ' + (i * 0.15) + 's';
      span.style.display = 'inline-block';
    });

    var observer = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) {
        spans.forEach(function (span) {
          span.style.opacity = '1';
          span.style.transform = 'translateY(0)';
        });
        observer.disconnect();
      }
    }, { rootMargin: '-80px' });
    observer.observe(container);
  });
}

/* ═══════════════════════════════════════════════
   6. STAGGERED COLOR WORDS
   ═══════════════════════════════════════════════ */

function initStaggeredColorWords() {
  var containers = document.querySelectorAll('.staggered-color-words');
  if (!containers.length) return;

  containers.forEach(function (container) {
    var observer = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) {
        container.classList.add('visible');
        observer.disconnect();
      }
    }, { rootMargin: '-100px' });
    observer.observe(container);
  });
}

/* ═══════════════════════════════════════════════
   7. SCROLL REVEAL TEXT
   ═══════════════════════════════════════════════ */

function initScrollRevealText() {
  var elements = document.querySelectorAll('.scroll-reveal-text');
  if (!elements.length) return;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }, { rootMargin: '-100px' });

  elements.forEach(function (el) { observer.observe(el); });
}

/* ═══════════════════════════════════════════════
   8. PARALLAX IMAGES
   ═══════════════════════════════════════════════ */

function initParallax() {
  var elements = document.querySelectorAll('.parallax-image__inner, .editorial-break__image');
  if (!elements.length) return;

  function updateParallax() {
    var scrollY = window.scrollY;
    var windowH = window.innerHeight;

    elements.forEach(function (el) {
      var rect = el.getBoundingClientRect();
      var elTop = rect.top + scrollY;
      var elH = rect.height;
      var progress = (scrollY + windowH - elTop) / (windowH + elH);
      progress = Math.max(0, Math.min(1, progress));
      var translate = (progress - 0.5) * 20;
      el.style.transform = 'translateY(' + translate + '%)';
    });
  }

  window.addEventListener('scroll', updateParallax, { passive: true });
  updateParallax();
}

/* ═══════════════════════════════════════════════
   9. HOME HERO VIDEO
   ═══════════════════════════════════════════════ */

function initHomeHeroVideo() {
  var hero = document.querySelector('.video-hero');
  if (!hero) return;

  var video = hero.querySelector('.video-hero__media');
  var overlayPlay = hero.querySelector('.video-hero__play-overlay');
  var playBtn = hero.querySelector('.video-hero__toggle-play');
  var muteBtn = hero.querySelector('.video-hero__toggle-mute');
  var fullscreenBtn = hero.querySelector('.video-hero__toggle-fullscreen');
  var playBtnIcon = playBtn ? playBtn.querySelector('[data-video-hero-play-icon]') : null;
  var muteBtnIcon = muteBtn ? muteBtn.querySelector('[data-video-hero-mute-icon]') : null;
  var playIcon = playBtnIcon ? playBtnIcon.querySelector('.video-hero__icon-play') : null;
  var pauseIcon = playBtnIcon ? playBtnIcon.querySelector('.video-hero__icon-pause') : null;
  var volumeOnIcon = muteBtnIcon ? muteBtnIcon.querySelector('.video-hero__icon-volume-on') : null;
  var volumeOffIcon = muteBtnIcon ? muteBtnIcon.querySelector('.video-hero__icon-volume-off') : null;
  var playBtnLabel = playBtn ? playBtn.querySelector('.video-hero__control-label') : null;
  var muteBtnLabel = muteBtn ? muteBtn.querySelector('.video-hero__control-label') : null;
  var progress = hero.querySelector('.video-hero__progress');
  var volume = hero.querySelector('.video-hero__volume');
  var currentTimeEl = hero.querySelector('.video-hero__time-current');
  var durationEl = hero.querySelector('.video-hero__time-duration');
  var desktopSrc = video ? video.getAttribute('data-src-desktop') : '';
  var mobileSrc = video ? video.getAttribute('data-src-mobile') : '';
  var desktopPoster = video ? video.getAttribute('data-poster-desktop') : '';
  var mobilePoster = video ? video.getAttribute('data-poster-mobile') : '';

  if (!video || !playBtn || !muteBtn || !fullscreenBtn || !progress || !volume) return;

  var isSeeking = false;
  var useMobileVideo = window.matchMedia('(max-width: 749px), (orientation: portrait)').matches;
  var initialSrc = useMobileVideo && mobileSrc ? mobileSrc : desktopSrc;
  var initialPoster = useMobileVideo && mobilePoster ? mobilePoster : desktopPoster;

  if (initialPoster) {
    video.poster = initialPoster;
  }

  if (initialSrc && video.getAttribute('src') !== initialSrc) {
    video.setAttribute('src', initialSrc);
    video.load();
  }

  function formatTime(seconds) {
    if (!isFinite(seconds)) return '00:00';
    var mins = Math.floor(seconds / 60);
    var secs = Math.floor(seconds % 60);
    return String(mins).padStart(2, '0') + ':' + String(secs).padStart(2, '0');
  }

  function updatePlayState() {
    var isPlaying = !video.paused && !video.ended;
    hero.classList.toggle('is-playing', isPlaying);
    if (playIcon) playIcon.hidden = isPlaying;
    if (pauseIcon) pauseIcon.hidden = !isPlaying;
    if (playBtnLabel) playBtnLabel.textContent = isPlaying ? 'Pause' : 'Play';
    playBtn.setAttribute('aria-label', isPlaying ? 'Pause video' : 'Play video');
  }

  function updateMuteState() {
    var silent = video.muted || video.volume === 0;
    if (volumeOnIcon) volumeOnIcon.hidden = !silent;
    if (volumeOffIcon) volumeOffIcon.hidden = silent;
    if (muteBtnLabel) muteBtnLabel.textContent = silent ? 'Unmute' : 'Mute';
    muteBtn.setAttribute('aria-label', silent ? 'Unmute video' : 'Mute video');
  }

  function updateTimeState() {
    if (!isSeeking && isFinite(video.duration) && video.duration > 0) {
      var progressValue = (video.currentTime / video.duration) * 100;
      progress.value = progressValue;
      progress.style.setProperty('--video-progress', progressValue + '%');
    }

    if (currentTimeEl) currentTimeEl.textContent = formatTime(video.currentTime);
    if (durationEl) durationEl.textContent = formatTime(video.duration);
  }

  function updateVolumeState() {
    var volumeValue = Math.max(0, Math.min(1, video.muted ? 0 : video.volume));
    volume.value = volumeValue;
    volume.style.setProperty('--video-volume', (volumeValue * 100) + '%');
    updateMuteState();
  }

  function dismissOverlay() {
    if (!overlayPlay) return;
    overlayPlay.hidden = true;
    overlayPlay.setAttribute('aria-hidden', 'true');
  }

  function requestPlay() {
    hero.classList.add('is-started');
    dismissOverlay();
    var playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {
        if (video.paused) {
          hero.classList.remove('is-started');
          overlayPlay.hidden = false;
          overlayPlay.removeAttribute('aria-hidden');
        }
      });
    }
  }

  if (video.hasAttribute('autoplay')) {
    video.removeAttribute('autoplay');
  }
  video.muted = false;
  video.volume = 1;
  video.controls = false;

  overlayPlay.addEventListener('click', function () {
    if (video.paused) {
      requestPlay();
    } else {
      video.pause();
    }
  });

  playBtn.addEventListener('click', function () {
    if (video.paused) {
      requestPlay();
    } else {
      video.pause();
    }
  });

  muteBtn.addEventListener('click', function () {
    if (video.muted || video.volume === 0) {
      video.muted = false;
      if (video.volume === 0) {
        video.volume = 1;
      }
    } else {
      video.muted = true;
    }
    updateVolumeState();
  });

  fullscreenBtn.addEventListener('click', function () {
    if (document.fullscreenElement === video || document.webkitFullscreenElement === video) {
      if (document.exitFullscreen) document.exitFullscreen();
      else if (document.webkitExitFullscreen) document.webkitExitFullscreen();
      return;
    }

    if (video.requestFullscreen) video.requestFullscreen();
    else if (video.webkitRequestFullscreen) video.webkitRequestFullscreen();
  });

  progress.addEventListener('input', function () {
    isSeeking = true;
    progress.style.setProperty('--video-progress', progress.value + '%');
    if (isFinite(video.duration) && video.duration > 0) {
      video.currentTime = (Number(progress.value) / 100) * video.duration;
    }
    updateTimeState();
  });

  progress.addEventListener('change', function () {
    isSeeking = false;
  });

  volume.addEventListener('input', function () {
    var nextVolume = Number(volume.value);
    video.muted = nextVolume === 0;
    video.volume = nextVolume;
    updateVolumeState();
  });

  video.addEventListener('play', updatePlayState);
  video.addEventListener('pause', updatePlayState);
  video.addEventListener('ended', updatePlayState);
  video.addEventListener('play', dismissOverlay);
  video.addEventListener('loadedmetadata', function () {
    updateTimeState();
    updateVolumeState();
  });
  video.addEventListener('timeupdate', updateTimeState);
  video.addEventListener('volumechange', updateVolumeState);

  updatePlayState();
  updateTimeState();
  updateVolumeState();
}

/* ═══════════════════════════════════════════════
   10. WAITLIST FORM
   ═══════════════════════════════════════════════ */

function initWaitlistForm() {
  var tierStep = document.getElementById('waitlist-step-tier');
  var formStep = document.getElementById('waitlist-step-form');
  var doneStep = document.getElementById('waitlist-step-done');
  if (!tierStep) return;

  var dots = document.querySelectorAll('.waitlist-dot');
  var tierCards = document.querySelectorAll('.tier-card');
  var form = document.getElementById('waitlist-form');
  var backBtn = document.getElementById('waitlist-back');
  var copyBtn = document.getElementById('copy-link-btn');
  var selectedTier = '';

  var tierNames = {
    'early-bird': 'Early Access',
    'vip-launch': 'RSVP LAUNCH',
    'inner-circle': 'Inner Circle'
  };

  function showStep(step) {
    tierStep.style.display = step === 'tier' ? 'block' : 'none';
    tierStep.classList.toggle('active', step === 'tier');
    formStep.style.display = step === 'form' ? 'block' : 'none';
    formStep.classList.toggle('active', step === 'form');
    doneStep.style.display = step === 'done' ? 'block' : 'none';
    doneStep.classList.toggle('active', step === 'done');

    dots.forEach(function (dot) {
      var s = dot.getAttribute('data-step');
      dot.classList.remove('active', 'completed');
      if (s === step) dot.classList.add('active');
      if (step === 'form' && s === 'tier') dot.classList.add('completed');
      if (step === 'done') dot.classList.add('completed');
    });
  }

  tierCards.forEach(function (card) {
    card.addEventListener('click', function () {
      selectedTier = card.getAttribute('data-tier');
      var borderColor = card.getAttribute('data-border-color');

      tierCards.forEach(function (c) {
        c.classList.remove('selected');
        c.style.borderColor = 'rgba(255,255,255,0.1)';
      });
      card.classList.add('selected');
      card.style.borderColor = borderColor;

      setTimeout(function () { showStep('form'); }, 400);
    });
  });

  if (backBtn) {
    backBtn.addEventListener('click', function () { showStep('tier'); });
  }

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var nameInput = form.querySelector('input[name="name"]');
      var name = nameInput ? nameInput.value : 'friend';

      var doneName = document.getElementById('waitlist-done-name');
      if (doneName) doneName.textContent = "You're on the list, " + (name || 'friend') + '.';

      var doneTier = document.querySelector('#waitlist-done-tier span');
      if (doneTier) doneTier.textContent = tierNames[selectedTier] || selectedTier;

      showStep('done');
    });
  }

  if (copyBtn) {
    copyBtn.addEventListener('click', function () {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(window.location.href);
        copyBtn.textContent = 'Copied!';
        setTimeout(function () { copyBtn.textContent = 'Copy Link'; }, 2000);
      }
    });
  }
}

/* ═══════════════════════════════════════════════
   11. CONTACT FORM
   ═══════════════════════════════════════════════ */

function initContactForm() {
  var form = document.getElementById('contact-form');
  if (!form) return;

  var formWrap = document.getElementById('contact-form-wrap');
  var thankYou = document.getElementById('contact-thank-you');
  var errorEl = document.getElementById('contact-form-error');
  var submitBtn = form.querySelector('button[type="submit"]');
  var stateEl = form.querySelector('[data-contact-form-state]');
  var postedSuccessfully = stateEl && stateEl.getAttribute('data-posted-successfully') === 'true';
  var hasErrors = stateEl && stateEl.getAttribute('data-has-errors') === 'true';
  var shouldRestoreView = postedSuccessfully || hasErrors;

  function scrollToContactState(target) {
    if (!target) return;

    window.requestAnimationFrame(function () {
      window.setTimeout(function () {
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 140);
    });
  }

  if (postedSuccessfully) {
    if (formWrap) formWrap.style.display = 'none';
    if (thankYou) thankYou.style.display = 'block';
  } else if (hasErrors) {
    if (formWrap) formWrap.style.display = 'block';
    if (thankYou) thankYou.style.display = 'none';
  }

  if (shouldRestoreView) {
    cleanContactPostedUrl();
    scrollToContactState(postedSuccessfully ? thankYou : formWrap);
  }

  // Focus/blur styling
  form.querySelectorAll('input, textarea').forEach(function (input) {
    input.addEventListener('focus', function () {
      input.style.borderBottomColor = 'var(--vibrant-orange)';
    });
    input.addEventListener('blur', function () {
      input.style.borderBottomColor = 'var(--orchid-mist)';
    });
  });

  form.addEventListener('submit', function (e) {
    var messageField = form.querySelector('textarea[name="contact[body]"]');
    var phoneField = form.querySelector('input[name="contact[phone]"]');
    var message = messageField ? messageField.value : '';
    var phoneValue = getPhoneNumberValue(phoneField);

    if (phoneField && phoneValue) {
      phoneField.value = phoneValue;
    }
    if (messageField && phoneValue && message.indexOf('\n\nPhone: ') === -1) {
      messageField.value = message + '\n\nPhone: ' + phoneValue;
    }

    if (errorEl) {
      errorEl.style.display = 'none';
      errorEl.textContent = '';
    }
    if (submitBtn) submitBtn.disabled = true;
  });
}
